import {custom_moment} from "momentCultured";
import {toUserFacingDate} from "@/utils/dateUtil.ts";

export function deliveryD8Str(d8: string, locale: string, t: (key: string, args?: any) => string) {
  
  const date = custom_moment(d8),
    now = custom_moment(),
    days = now.clone().startOf('day').diff(date.clone().startOf('day'), 'days'),
    hours = now.diff(date, 'hours');

  let str = '';

  if (days > 7) {
    str = toUserFacingDate(d8, false, locale);
  } else if (days >= 2) {
    str = t('patient_dashboard_delivery_time', [days, days > 1 ? t('days_lowercase_pluralization_many') : t('day_lowercase_pluralization_one')]);
  } else if (days === 1) {
    str = t('gen_yesterday_initialCap');
  } else if (hours >= 1) {
    str = t('patient_dashboard_delivery_time', [hours,  hours > 1 ? t('hours_lowercase_pluralization_many') : t('hour_lowercase_pluralization_one')]);
  } else if (hours === 0) {
    str = t('patient_dashboard_delivery_time_now');
  }

  return str;
}